module.exports = __webpack_public_path__ + "img/2.5-车耳营迎客松（杨树田-摄）.2cb352e8.jpg";